namespace GeniuzPOS.InventoryReport {
    export class IcReport07SkuColumns {
        static columnsKey = 'InventoryReport.IcReport07Sku';
    }
}
